import React from 'react';
import {getMarkerEnd, EdgeText} from 'react-flow-renderer';

const isVertical = (position) =>
  ['left', 'right'].includes(position.split(' ')[0]);

const getOffset = (position) =>
  ['left', 'top'].includes(position.split(' ')[0]) ? -20 : 20;

export const RaisedEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style = {},
  data,
  arrowHeadType,
  markerEndId,
  label,
  labelStyle,
  labelShowBg,
  labelBgStyle,
  labelBgPadding,
  labelBgBorderRadius,
}) => {
  const offset = getOffset(sourcePosition);
  // Whether the edge is moving from left to right (horizontal) or top to bottom (vertical)
  const vertical = isVertical(sourcePosition);

  // The SVG paths
  const HORIZONTAL_PATH = `M ${sourceX} ${sourceY} L ${sourceX} ${sourceY +
    offset} L ${targetX} ${targetY + offset} L ${targetX} ${targetY}`;
  const VERTICAL_PATH = `M ${sourceX} ${sourceY} L ${sourceX +
    offset} ${sourceY} L ${targetX +
    offset} ${targetY} L ${targetX} ${targetY}`;

  const d = vertical ? VERTICAL_PATH : HORIZONTAL_PATH;

  const markerEnd = getMarkerEnd(arrowHeadType, markerEndId);

  // Calculate the center positions so we can add the edge label
  const centerX = vertical
    ? sourceX + offset
    : sourceX + (targetX - sourceX) / 2;
  const centerY = vertical
    ? sourceY + (targetY - sourceY) / 2
    : sourceY + offset;

  return (
    <>
      <path
        id={id}
        style={style}
        className="react-flow__edge-path"
        d={d}
        markerEnd={markerEnd}
      />
      <EdgeText
        x={centerX}
        y={centerY}
        label={label}
        labelStyle={labelStyle}
        labelShowBg={labelShowBg}
        labelBgStyle={labelBgStyle}
        labelBgPadding={labelBgPadding}
        labelBgBorderRadius={labelBgBorderRadius}
      />
    </>
  );
};
